import React, { useState } from 'react';
import { useData } from '../context/DataContext';
import { db, STORES } from '../db/database';

const Regroupements = () => {
  const { regroupements, refreshData } = useData();
  const [newRegroupement, setNewRegroupement] = useState({
    type: 'client',
    nomOriginal: '',
    nomRegroupe: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewRegroupement(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newRegroupement.nomOriginal || !newRegroupement.nomRegroupe) {
      alert('Veuillez remplir tous les champs');
      return;
    }

    try {
      await db.add(STORES.REGROUPEMENTS, newRegroupement);
      await refreshData();
      setNewRegroupement({ type: 'client', nomOriginal: '', nomRegroupe: '' });
    } catch (error) {
      console.error('Erreur ajout regroupement:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Supprimer ce regroupement ?')) {
      try {
        await db.delete(STORES.REGROUPEMENTS, id);
        await refreshData();
      } catch (error) {
        console.error('Erreur suppression:', error);
      }
    }
  };

  return (
    <div>
      <h2>🔗 Regroupements</h2>
      <p className="info-text">
        Permet de fusionner plusieurs orthographes d'un même client ou chantier.
      </p>

      <form onSubmit={handleSubmit} className="regroupement-form">
        <select name="type" value={newRegroupement.type} onChange={handleChange} aria-label="Type">
          <option value="client">👤 Client</option>
          <option value="chantier">🏗️ Chantier</option>
        </select>
        <input
          name="nomOriginal"
          value={newRegroupement.nomOriginal}
          onChange={handleChange}
          placeholder="Nom dans Tolteck *"
          required
          aria-label="Nom original"
        />
        <input
          name="nomRegroupe"
          value={newRegroupement.nomRegroupe}
          onChange={handleChange}
          placeholder="Nom regroupé *"
          required
          aria-label="Nom regroupé"
        />
        <button type="submit">Ajouter</button>
      </form>

      <div className="table-scroll">
        <table className="data-table" role="table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Nom original</th>
            <th>Nom regroupé</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {(regroupements || []).map(r => (
            <tr key={r.id}>
              <td>{r.type === 'client' ? '👤 Client' : '🏗️ Chantier'}</td>
              <td>{r.nomOriginal}</td>
              <td><strong>{r.nomRegroupe}</strong></td>
              <td>
                <button 
                  className="btn-delete"
                  onClick={() => handleDelete(r.id)}
                  aria-label="Supprimer ce regroupement"
                >
                  🗑️
                </button>
              </td>
            </tr>
          ))}
          {(!regroupements || regroupements.length === 0) && (
            <tr>
              <td colSpan="4" style={{ textAlign: 'center', color: 'var(--color-text-secondary)', padding: '2rem' }}>
                Aucun regroupement défini
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default Regroupements;